import React from 'react';
import Input from "../../theme/forms/Input";
import PublicTopNav from "../../theme/nav/PublicTopNav";
import BaseHomePageLogoWrapper from "../../theme/logoCards/baseHomePageLogoWrapper"
import {addErrorAlert, toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";
import BaseModal from "../../theme/modals/BaseModal";
import MapFrame from "../../theme/maps/mapFrame";
import PacefiFullScreenSpinner from "../../theme/loaders/pacefiFullScreenSpinner";

export default class AboutPage extends React.Component {


    constructor(props) {
        super(props);
    }


    componentDidMount() {
        toggleGlobalLoader(false);
    }


    render() {

        return (
            <div id="homepage-wrapper">
                <PublicTopNav/>
                <section className="hero">
                    <div className="hero-body">
                        <div className="columns">
                            <div className="column" style={{maxWidth: '1000px'}}>
                                <div className="mb-6">
                                    <div className="title has-text-primary">
                                        Our mission
                                    </div>
                                    <div className="is-size-4">
                                        We're here to make buildings resilient, green, and healthy to occupy. We do that by making
                                        financing of these upgrades as easy as possible.
                                    </div>
                                </div>
                                <div className="mb-6">
                                    <div className="title has-text-primary">
                                        What we do
                                    </div>
                                    <div className="is-size-4">
                                        CleanFi is a free platform designed to lower the soft costs associated with
                                        those commercial building improvements that advance resiliency,
                                        environmental health, resource efficiency and resource independence. We help
                                        fund hundreds of project scopes that
                                        touch on every aspect of a building’s envelope and functionality.
                                    </div>
                                </div>
                                <div className="mb-6">
                                    <div className="title has-text-primary">
                                        What we finance
                                    </div>
                                    <div className="content" >

                                        <span className="is-size-4">
                                        We present long-term financing solutions for anything that involves a commercial
                                        real estate properties:
                                            </span>
                                        <ul>
                                            <li>building envelope (roofs, outside walls, windows and doors,..)</li>
                                            <li>structural resiliency</li>
                                            <li>resource efficiency (energy, water, airflow)</li>
                                            <li>resource independence (renewable energy, storage, thermal,..)</li>
                                            <li>new transportation (EVcharging, H2 fueling,..)</li>
                                            <li>internal air quality (heat pumps, HVAC, control,...)</li>
                                            <li>hundreds of other improvements</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="mb-6">
                                    <div className="title has-text-primary">
                                        Which properties are eligible?
                                    </div>
                                    <div className="is-size-4">
                                        CleanFi has funding products from numerous financing institutions; and we are
                                        taking on new ones regularly that want to compete, or solve a specific problem,
                                        or work with a specific region. We serve any commercial property anywhere in the
                                        United States, retrofit or ground-up, ag or urban, single-proprietor or HOA,
                                        skyscraper or strip-mall.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <PacefiFullScreenSpinner/>
            </div>

        )
    }

}


